import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../TextField/TextFeild";
import SelectBox from "../CountryDropDown/SelectBox";
import { addTeamMember } from "../../store/slices/teamSlice";

// Step 1 validation
const step1Validation = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
});

// Step 2 validation
const step2Validation = Yup.object({
    password: Yup.string().required("Password is required"),
    passwordRepeat: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    roles: Yup.array().min(1, "Role is required"),
});

const AddPoll = ({ show, onClose }) => {
    const dispatch = useDispatch();
    const [step, setStep] = useState(1);

    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            passwordRepeat: '',
            roles: '',
        },
        validationSchema: step === 1 ? step1Validation : step2Validation,
        onSubmit: async (values, { resetForm }) => {
            const submitValues = { ...values };
            delete submitValues.passwordRepeat;

            dispatch(addTeamMember({
                message: "Team member created.",
                palyload: { id: values.email, values: submitValues }
            }))
            .unwrap()
            .then(() => {
                onClose();
            });
        },
    });

    useEffect(() => {
        if (show) {
            formik.resetForm();
            setStep(1);
        }
    }, [show]);

    const nextStep = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length === 0) {
                setStep(2);
            } else {
                formik.setTouched(errors);
            }
        });
    };

    const prevStep = () => setStep(1);

    return (
        <Modal show={show} size="lg" onHide={onClose} centered backdrop="static" keyboard={false}>
            <form onSubmit={formik.handleSubmit}>
                <div className="form-card shadow-none p-4">

                    {step === 1 && (
                        <>
                            <CustomInput
                                label="First Name"
                                id="firstName"
                                name="firstName"
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.firstName && formik.errors.firstName}
                                required
                            />
                            <CustomInput
                                label="Last Name"
                                id="lastName"
                                name="lastName"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.lastName && formik.errors.lastName}
                                required
                            />
                            <CustomInput
                                label="Email"
                                id="email"
                                name="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && formik.errors.email}
                                required
                            />
                        </>
                    )}

                    {step === 2 && (
                        <>
                            <CustomInput
                                label="Password"
                                id="password"
                                name="password"
                                type="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.password && formik.errors.password}
                                required
                            />
                            <CustomInput
                                label="Repeat Password"
                                id="passwordRepeat"
                                name="passwordRepeat"
                                type="password"
                                value={formik.values.passwordRepeat}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.passwordRepeat && formik.errors.passwordRepeat}
                                required
                            />
                            <SelectBox
                                name="roles"
                                selectedValue={formik.values.roles}
                                onChangeFn={(value) => formik.setFieldValue("roles", value)}
                                label="Role"
                                options={[{ label: "DJ", value: ['dj'] }]}
                                onBlur={formik.handleBlur}
                                value={formik.values.roles}
                                error={formik.touched.roles && formik.errors.roles}
                                isSearchable={false}
                            />
                        </>
                    )}

                    <div className="d-flex justify-content-between mt-4">
                        <div>
                            {step === 2 && (
                                <button type="button" className="btn btn-outline-secondary" onClick={prevStep}>
                                    Back
                                </button>
                            )}
                        </div>
                        <div>
                            <button type="button" className="btn btn-outline-danger mx-2" onClick={onClose}>
                                Cancel
                            </button>
                            {step === 1 ? (
                                <button type="button" className="btn btn-primary" onClick={nextStep}>
                                    Next
                                </button>
                            ) : (
                                <button type="submit" className="btn btn-secondary" disabled={formik.isSubmitting}>
                                    {formik.isSubmitting ? "Creating..." : "Create"}
                                </button>
                            )}
                        </div>
                    </div>

                </div>
            </form>
        </Modal>
    );
};

export default AddPoll;
